import { httpApi } from "api/http.api";
import { AxiosError, AxiosResponse } from "axios";
import {
  ChangePasswordData,
  CreateCustomerAccountData,
  ForgotPasswordData,
  ResetPasswordData,
  UpdateUsernameData,
  UserData,
  UsersData,
} from "interfaces/ApiInterface/ILoginFormData";

// Function to authenticate a user login
export const loginUser = (userData: UserData, portalId: number) => {
  const url = "/users/login";
  const data = {
    PortalId: portalId,
    User: {
      Username: userData?.username,
      Password: userData?.password,
    },
  };
  return httpApi
    .post(url, data)
    .then((response) => {
      return response.data;
    })
    .catch((error: AxiosError) => {
      throw error;
    });
};

// Function to create a customer account
export const createCustomerAccount = (data: CreateCustomerAccountData) => {
  const url = "/users/CreateCustomerAccount";
  const requestBody = {
    IsWebStoreUser: data.IsWebStoreUser,
    PortalId: data.PortalId,
    UserVerificationTypeCode: data.UserVerificationTypeCode,
    Email: data.Email,
    User: {
      Email: data?.User?.Username,
      Password: data?.User?.Password,
      Username: data?.User?.Username,
    },
  };
  return httpApi
    .post(url, requestBody)
    .then((response) => response)
    .catch((error: AxiosError) => {
      throw error;
    });
};

// Function to initiate the forgot password process
export const forgotPassword = (data: ForgotPasswordData) => {
  const url = "/users/ForgotPassword";
  return httpApi
    .post(url, data)
    .then((response) => response.data)
    .catch((error: AxiosError) => {
      throw error;
    });
};

// Function to change user password
export const changePassword = (data: ChangePasswordData) => {
  const url = "/users/changepassword";
  return httpApi
    .post(url, data)
    .then((response) => response.data)
    .catch((error: AxiosError) => {
      throw error;
    });
};

// Function to update user profile
export const updateUserProfile = (data: UsersData) => {
  const url = "/useraccount/update/true";
  return httpApi
    .put(url, data)
    .then((response) => response.data)
    .catch((error: AxiosError) => {
      throw error;
    });
};

// Function to update user profile, if it has changed Username only
export const updateUsername = (data: UpdateUsernameData) => {
  const url = "/username/updateusernameforregistereduser";
  return httpApi
    .put(url, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

// Function to Reset user password
export const resetPassword = (data: ResetPasswordData) => {
  const url = "/users/ChangePassword";
  return httpApi
    .post(url, data)
    .then((response) => response.data)
    .catch((error: AxiosError) => {
      throw error;
    });
};

export const getTagManagerId = (portalId: number) => {
  return httpApi
    .get(`tagmanager/get/${portalId}`)
    .then((response: AxiosResponse) => response)
    .catch((err: AxiosError) => {
      throw err;
    });
};

export const getRobotTxt = (portalId: number) => {
  return httpApi
    .get(`portal/getrobotstxt/${portalId}`)
    .then((response: AxiosResponse) => response)
    .catch((err: AxiosError) => {
      throw err;
    });
};
